import {
    ADD_FAVOURITE_SECURITY_SUCCESS,
    FETCH_ALL_SECURITY_SUCCESS,
    FETCH_SECURITY_SUCCESS,
    FILTER_SECURITY,
    GET_ALL_SECURITY,
    GET_UNSELECTED_ALL_SECURITY,
    HANDLE_SECURITY_REQUEST_CLOSE,
    HIDE_SECURITY_LOADER,
    SHOW_SECURITY_LOADER,
    ON_ADD_SECURITY,
    ON_ALL_SECURITY_SELECT,
    ON_SECURITY_CLOSE,
    ON_SECURITY_SELECT,
    ON_DELETE_SECURITY_SUCCESS,
    ON_FILTER_SELECTED_SECURITY,
    ON_FILTER_SECURITY_OPTION_SELECT,
    ON_SAVE_SECURITY_SUCCESS,
    ON_TOGGLE_SECURITY_DRAWER,
    SHOW_SECURITY_MESSAGE,
    UPDATE_SEARCH_SECURITY,
    CLEAR_SESSION,
    CLEAR_SELECTED_OBJECTS,
} from 'constants/ActionTypes';
import { addOrUpdateEntry } from 'services/arrayService';

export const ALL_FILTER = 'All securities';
export const STARRED_FILTER = 'Starred securities';
export const SUCCESSFUL_UPDATE = 'Security Updated Successfully';
export const SUCCESSFUL_FILTER = 'Security Filtered Successfully';
export const SUCCESSFUL_DELETE = 'Security Deleted Successfully';
export const REMOVED_AS_STAR = 'Security removed as star';
export const MARKED_AS_STAR = 'Security marked as star';

export const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No securities found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: ALL_FILTER,
    allSecurity: [],
    securityList: [],
    selectedSecurity: null,
    selectedSecuritys: 0,
    addSecurityState: false,
    searchSecurity: '',
    security: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'http://via.placeholder.com/150x150',
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case CLEAR_SELECTED_OBJECTS: {
            return {
                ...state,
                selectedSecurity: null,
            };
        }
        case ADD_FAVOURITE_SECURITY_SUCCESS: {
            const allUpdated = state.allSecurity.map((entry) =>
                entry?.id === action?.payload?.id
                    ? {
                          ...entry,
                          starred: !action?.payload?.starred,
                      }
                    : entry
            );
            let listUpdated = {};
            switch (state.filterOption) {
                case ALL_FILTER: {
                    listUpdated = allUpdated;
                    break;
                }
                case STARRED_FILTER: {
                    listUpdated = allUpdated.filter((entry) => entry.starred);
                    break;
                }
            }
            return {
                ...state,
                alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
                showMessage: true,
                securityList: listUpdated,
                allSecurity: allUpdated,
            };
        }
        case FETCH_SECURITY_SUCCESS: {
            return {
                ...state,
                loader: false,
                selectedSecurity: action.payload,
            };
        }
        case FETCH_ALL_SECURITY_SUCCESS: {
            return {
                ...state,
                loader: false,
                allSecurity: action.payload,
                securityList: action.payload,
                selectedSectionId: 1,
                searchEmp: '',
                filterOption: ALL_FILTER,
            };
        }
        case SHOW_SECURITY_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false,
            };
        }
        case ON_SECURITY_SELECT: {
            action.payload.selected = !action.payload.selected;
            let selectedSecuritys = 0;
            const securityList = state.securityList.map((security) => {
                if (security.selected) {
                    selectedSecuritys++;
                }
                if (security.id === action.payload.id) {
                    if (security.selected) {
                        selectedSecuritys++;
                    }
                    return action.payload;
                } else {
                    return security;
                }
            });
            return {
                ...state,
                INIT_STATE,
                selectedSecuritys: selectedSecuritys,
                securityList: securityList,
            };
        }
        case ON_ADD_SECURITY: {
            return { ...state, addSecurityState: true };
        }
        case ON_SECURITY_CLOSE: {
            return { ...state, addSecurityState: false };
        }
        case ON_FILTER_SECURITY_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let securityList = [];
            switch (action.payload.name) {
                case ALL_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    securityList = state.allSecurity;
                    break;
                }
                case STARRED_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    securityList = state.allSecurity.filter((security) => security.starred);
                    break;
                }
            }
            return {
                ...state,
                selectedSectionId,
                filterOption,
                securityList,
                drawerState: false,
            };
        }
        case ON_SAVE_SECURITY_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_UPDATE,
                showMessage: true,
                securityList: addOrUpdateEntry(state.securityList, action.payload),
                allSecurity: addOrUpdateEntry(state.allSecurity, action.payload),
                loader: false,
            };
        }
        // called after a delete from the db operation to keep the current state up to date
        case ON_DELETE_SECURITY_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_DELETE,
                showMessage: true,
                allSecurity: state.allSecurity.filter((security) => security.id !== action.payload),
                securityList: state.allSecurity.filter((security) => security.id !== action.payload),
                selectedSecurity: null,
            };
        }
        // not a delete but a filter of the UI
        case ON_FILTER_SELECTED_SECURITY: {
            const securitys = state.allSecurity.filter((security) => !security.selected);
            return {
                ...state,
                alertMessage: SUCCESSFUL_FILTER,
                showMessage: true,
                securityList: securitys,
                selectedSecuritys: 0,
            };
        }
        case FILTER_SECURITY: {
            const { filterOption } = state;
            let securityList = [];
            if (action.payload === '') {
                securityList = state.allSecurity;
            } else {
                const filterSecurity = state.allSecurity.filter((security) => security.name.toLowerCase().indexOf(action.payload.toLowerCase()) > -1);
                if (filterOption === ALL_FILTER) {
                    securityList = filterSecurity;
                } else if (filterOption === STARRED_FILTER) {
                    securityList = filterSecurity.filter((security) => security.starred);
                }
            }
            return { ...state, securityList: securityList };
        }
        case GET_ALL_SECURITY: {
            let securityList = state.allSecurity.map((security) =>
                security
                    ? {
                          ...security,
                          selected: true,
                      }
                    : security
            );
            return {
                ...state,
                selectedSecuritys: securityList.length,
                allSecurity: securityList,
                securityList: securityList,
            };
        }
        case GET_UNSELECTED_ALL_SECURITY: {
            let securityList = state.allSecurity.map((security) =>
                security
                    ? {
                          ...security,
                          selected: false,
                      }
                    : security
            );
            return {
                ...state,
                selectedSecuritys: 0,
                allSecurity: securityList,
                securityList: securityList,
            };
        }
        case ON_ALL_SECURITY_SELECT: {
            const selectAll = state.selectedSecuritys < state.securityList.length;
            let selectedSecuritys = 0;
            let securityList = [];
            if (selectAll) {
                securityList = state.allSecurity.map((security) =>
                    security
                        ? {
                              ...security,
                              selected: true,
                          }
                        : security
                );
                selectedSecuritys = securityList.length;
            } else {
                securityList = state.allSecurity.map((security) =>
                    security
                        ? {
                              ...security,
                              selected: true,
                          }
                        : security
                );
                selectedSecuritys = 0;
            }
            return {
                ...state,
                selectedSecuritys: selectedSecuritys,
                allSecurity: securityList,
                securityList: securityList,
            };
        }
        case UPDATE_SEARCH_SECURITY: {
            return { ...state, searchSecurity: action.payload };
        }
        case HANDLE_SECURITY_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_SECURITY_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_SECURITY_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_SECURITY_LOADER: {
            return { ...state, loader: false };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/security.js